// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1xeVU","requiredAsterisk":"Info_requiredAsterisk__1GkZZ"};